<div class="input-group input-group-sm">
    <spv2-jurisdiction-obligation-options-dropdown [textField]="'code'" [(value)]="value" [smallView]="smallView" (valueChange)="valueChange.emit($event)" (userChangedValue)="startDebounce();" ></spv2-jurisdiction-obligation-options-dropdown>
</div>  